import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="header"
export default class extends Controller {
  toggleMenu() {
    this.element.classList.toggle('open');
  }
}
